import {
   ChangeDetectorRef,
   Component,
   ElementRef,
   Input,
   OnChanges,
   OnInit,
   SimpleChanges,
   ViewContainerRef,
} from '@angular/core';
import { ExtensionGroupOption } from 'src/app/pages/extension-register/models/extension-group-option.interface';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ExtensionAndExtensionGroupSelectComponent,
        },
    ],
    selector: 'ndt-extension-and-group-select',
    templateUrl: './extension-and-group-select.component.html',
    standalone: false
})
export class ExtensionAndExtensionGroupSelectComponent
   extends LcsSingleSelectBase<ExtensionGroupOption | ExtensionOption>
   implements OnInit, OnChanges
{
   @Input() extensionGroupIdsToExclude: number[] = [];

   @Input() extensionIdsToExclude: number[] = [];

   @Input() extensionGroups: ExtensionGroupOption[] = [];

   @Input() extensions: ExtensionOption[] = [];

   filteredOptions: (ExtensionGroupOption | ExtensionOption)[] = [];

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.updateFilteredOptions();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (
         changes.extensionGroups ||
         changes.extensions ||
         changes.extensionGroupIdsToExclude ||
         changes.extensionIdsToExclude
      ) {
         this.updateFilteredOptions();
      }
   }

   updateFilteredOptions(): void {
      const filteredGroups = this.extensionGroups.filter(
         (group) =>
            !Array.isArray(this.extensionGroupIdsToExclude) ||
            !this.extensionGroupIdsToExclude.includes(group.extensionGroupId)
      );

      const filteredExtensions = this.extensions.filter(
         (ext) => !Array.isArray(this.extensionIdsToExclude) || !this.extensionIdsToExclude.includes(ext.extensionId)
      );

      this.filteredOptions = [...filteredGroups, ...filteredExtensions];
   }

   displayWith(item: ExtensionGroupOption | ExtensionOption | null): string | null {
      if (!item) return null;
      if (this.isExtensionGroup(item)) {
         if (!item.name || item.name.trim() === '') {
            return item.description ? `${item.description} (group)` : '(Unnamed group)';
         } else if (item.description && item.description.trim() !== '') {
            return `${item.name} - ${item.description} (group)`;
         } else {
            return `${item.name} (group)`;
         }
      } else {
         return item.name ? `${item.number} - ${item.name}` : null;
      }
   }

   trackBy = (item: ExtensionGroupOption | ExtensionOption | null): any => {
      if (item === null || typeof item !== 'object') {
         return null;
      }
      return 'extensionGroupId' in item ? item.extensionGroupId : item.extensionId;
   };

   public isExtensionGroup(item: ExtensionGroupOption | ExtensionOption): item is ExtensionGroupOption {
      return 'extensionGroupId' in item;
   }
}
